/* ORVELA — subtle reveal on scroll. No parallax, no per-element animation. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    var nodes = document.querySelectorAll('.o-reveal');
    if (!nodes.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    nodes.forEach(function (n) { io.observe(n); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
